export default __webpack_public_path__ + "static/media/mIcon.1c9cb7de.png";